import {System} from '../../shared-components/System';
import { Lookup } from '../../shared-components/lookup/lookup.model';

export class GPFilterParam {

	static planTypes: Lookup[];
	static planStatuses = ['Complete', 'Incomplete'];
	static areaStatuses = ['Complete', 'Incomplete'];
	static creditCodeStatuses = ['Complete', 'Incomplete'];
	static courseStatuses = ['Complete', 'Incomplete'];

	static get planTypeMap() {
		return GPFilterParam.planTypes ? GPFilterParam.planTypes.map(x => x.Code) : [];
	}

	static get planStatusMap() {
		return GPFilterParam.planStatuses.map(x => x);
	}

	static get areaStatusMap() {
		return GPFilterParam.areaStatuses.map(x => x);
	}

	static get creditCodeStatusMap() {
		return GPFilterParam.creditCodeStatuses.map(x => x);
	}

	static get courseStatusMap() {
		return GPFilterParam.courseStatuses.map(x => x);
	}

    DefaultDisplay: string;
    CreditDecimalPrecision: number;
    PlanType: string[] = [];
    PlanGroup: string[] = [];
    GradPlanStatus: string[] = [];
    SubjectAreaStatus: string[] = [];
    CreditCodeStatus: string[] = [];
    CourseStatus: string[] = [];
    GPNeeded: number;
    showAllGP = false;
    notInGP = false;

    _init_defaultDisplay = 'GP|SA';
    _init_CreditDecimalPrecision = 4;
    _init_PlanType = 'all';
    _init_PlanGroup = 'all';
    _init_GradPlanStatus = 'all';
    _init_SubjectAreaStatus = 'all';
    _init_CreditCodeStatus = 'all';
    _init_GPNeeded = 0;
    _init_showAllGP = false;
    _init_notInGP = false;
    _init_CourseStatus = 'all';

    constructor() {
        this.init();
    }

    isFilterApplied(): boolean {
        return (
            this.DefaultDisplay != this._init_defaultDisplay ||
            !(this.PlanType.includes(this._init_PlanType)  || System.arrayEqual(GPFilterParam.planTypeMap, this.PlanType))  ||
            !(this.PlanGroup.includes(this._init_PlanGroup)) ||

            !(this.GradPlanStatus.includes(this._init_GradPlanStatus) || System.arrayEqual(GPFilterParam.planStatusMap, this.GradPlanStatus)) ||
            !(this.SubjectAreaStatus.includes(this._init_SubjectAreaStatus) || System.arrayEqual(GPFilterParam.areaStatusMap, this.SubjectAreaStatus)) ||
            !(this.CreditCodeStatus.includes(this._init_CreditCodeStatus) || System.arrayEqual(GPFilterParam.creditCodeStatusMap, this.CreditCodeStatus)) ||
			!(this.CourseStatus.includes(this._init_CourseStatus) || System.arrayEqual(GPFilterParam.courseStatusMap, this.CourseStatus)) ||
            this.CreditDecimalPrecision != this._init_CreditDecimalPrecision ||
            this.GPNeeded != this._init_GPNeeded
        );
    }

    init() {
        this.DefaultDisplay = this._init_defaultDisplay;
        this.PlanType = [this._init_PlanType];
        this.PlanGroup = [this._init_PlanGroup];

        this.GradPlanStatus = [this._init_GradPlanStatus];
        this.SubjectAreaStatus = [this._init_SubjectAreaStatus];
        this.CreditCodeStatus = [this._init_CreditCodeStatus];
		this.CourseStatus = [this._init_CourseStatus];

        this.CreditDecimalPrecision = this._init_CreditDecimalPrecision;
        this.GPNeeded = this._init_GPNeeded;
        // this.showAllGP = this._init_showAllGP;
        // this.notInGP  = this._init_notInGP;
    }
}